"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.promotionRepositoryMethods = void 0;
const repository_types_1 = require("../webapp/repository.types");
exports.promotionRepositoryMethods = (0, repository_types_1.generateRepositoryMethods)({
    getAllPromotions: {
        callMethod: 'GET',
        endpoint: '/promotions/all',
    },
    getPromotionsById: {
        callMethod: 'GET',
        endpoint: '/promotions/by-id',
    },
    updatePromotion: {
        callMethod: 'PUT',
        endpoint: '/promotions/update',
    },
    createPromotion: {
        callMethod: 'POST',
        endpoint: '/promotions/create',
    },
    exportPromotionsAsCsv: {
        callMethod: 'GET',
        endpoint: '/promotions/export/csv',
    },
    setPromotionsLastRunning: {
        callMethod: 'PUT',
        endpoint: '/promotions/set-last-running',
    },
});
//# sourceMappingURL=promotion.methods.js.map